












































































































import {Vue, Component} from 'vue-property-decorator';
import {Subject} from 'rxjs';
import {Util} from '@/utils';
import AppCenterService from "@service/app/app-center-service";
import AppChangePassword from "@components/app-change-password/app-change-password.vue";

@Component({
  components: {AppChangePassword}
})
export default class AppUser extends Vue {
  public checkPhone = (rule:any, value:any, callback:any) => {
    let reg = /^\d{4}$/
    if (!reg.test(value) && value) {
        callback(new Error('请输入四位数字'))
    } else {
        callback()
    }
  }
  public phoneRules:any = {
          agentExt: [
            // { required: true, type: 'string', message: '分机号不能为空', trigger: 'change' },
            // { required: true, type: 'string', message: '分机号不能为空', trigger: 'blur' },
            { type: 'number', validator: this.checkPhone, message: '请填写正确的分机号', trigger: 'change' },
            { type: 'number', validator: this.checkPhone, message: '请填写正确的分机号', trigger: 'blur' },
          ],
          agentId: [
            { required: true, type: 'string', message: '坐席号不能为空', trigger: 'change' },
            { required: true, type: 'string', message: '坐席号不能为空', trigger: 'blur' },
          ]
  }
  /**
   * 修改密码弹窗
   */
  public modalVisible: boolean = false;

  /**
   * 坐席信息
   */
  public phoneInfo = {'agent':'','agentId':'','agentExt':''};

  /**
   * 坐席信息弹窗
   */
  public phoneVisible: boolean = false;

  /**
   * 二维码弹窗
   */
  public qrCodeVisible: boolean = false;
  /**
   public isPassWord: boolean = true;
   public isPassWordConfirm: boolean = true;
   // 是否允许关闭
   public canClose: boolean = true;
   public passwordForm = {
        newPassWord: "",
        confirmPassword: ""
    }
   public checkPassWord(rule :any, value : any, callback : any){
          let reg : any = /^(([a-z]|[A-Z])*) | (\d*)$/
                if (value) {
                    if (reg.test(value) || value.length < 6) {
                        callback(new Error("密码过于简单！密码长度不能少于6位，不能全为数字或者字母"));
                    } else {
                        callback();
                    }
                }
     }
   public passwordRule = {
            newPassWord: [
                    { required: true, message: '新密码不能为空', trigger: 'blur' },
                    { validator: this.checkPassWord, trigger: "change" }
                ],
            confirmPassword: [
                    { required: true, message: '确认密码不能为空', trigger: 'blur' },
                     { validator: this.checkPassWord, trigger: "change" }
                ],
        }

   public passowordClick(){
        this.isPassWord = !this.isPassWord
    }
   public isPassWordConfirmClick(){
        this.isPassWord = true;
        this.isPassWordConfirm = true;
        this.isPassWordConfirm = !this.isPassWordConfirm;
    }
   public onVisibleChange() {
          const refs = (this.$refs) as any;
          refs.passwordFormRef.resetFields();
    }
   public changePassWordConfirm(){
        const refs = (this.$refs) as any;
              refs.passwordFormRef.validate((valid : boolean) => {
                    if (valid) {
                        // 验证两次输入的密码是否相同
                        if(this.passwordForm.newPassWord != this.passwordForm.confirmPassword) {
                             this.$Message.error('两次密码输入不相同，请重新输入');
                            return;
                        }
                        const post: Promise<any> = this.$http.post('/runtimeapi/v7/changePassword', this.passwordForm.newPassWord, true);
                        post.then((res:any) => {
                            localStorage.setItem('token', res.data);
                            Util.setCookie('sysuaa-token',res.data,0);
                            this.modalVisible = false;
                            this.canClose = true;
                            this.$Message.success('密码修改成功!');
                        }).catch(err => {
                            this.$Message.error('密码修改失败!');
                        })

                    }
                })
    }
   */

  /**
   * 用户信息
   *
   * @memberof AppUser
   */
  public user = {
    name: '',
    // avatar: './assets/img/avatar.png',
    avatar: './assets/img/klg.jpg',
  }
  get isChangePwd(){
    let information:any=localStorage.getItem('user')
    let userInfo = JSON.parse(information);
    // let canChangePwd=userInfo.permissionList.authorities.includes('UNIRES_cssworkorder-CHANGE-PASSWORD')
    return userInfo.sessionParams.extusertype != '1'
  }
  /**
   * 下拉选选中回调
   *
   * @param {*} data
   * @memberof AppUser
   */
  public userSelect(data: any) {
    if (Object.is(data, 'logout')) {
      const title: any = this.$t('components.appUser.surelogout');
      this.$Modal.confirm({
        title: title,
        onOk: () => {
          this.logout();
        }
      });
    } else if (Object.is(data, 'updatepwd')) {
      // let container: Subject<any> = this.$appmodal.openModal({ viewname: 'app-update-password', title: (this.$t('components.appUser.changepwd') as string),  width: 500, height: 400, }, {}, {});
      //         container.subscribe((result: any) => {
      //             if (!result || !Object.is(result.ret, 'OK')) {
      //                 return;
      //             }
      // });
      AppCenterService.notifyMessage({
        name: "isFirstLogin",
        action: 'changepassword',
        data: {'canClose': true, "modalVisible": true}
      })

    }
  }


  /**
   * vue  生命周期
   *
   * @memberof AppUser
   */
  public mounted() {
    // 获取redis坐席信息并初始化电话条
    // this.getUserAgentFromRedis()
    if(this.isHotLineSpec()){
      this.showPhoneDialog()
    }

    let _user: any = {};
    if (this.$store.getters.getAppData()) {
      if (this.$store.getters.getAppData().context && this.$store.getters.getAppData().context.srfusername) {
        _user.name = this.$store.getters.getAppData().context.srfusername;
      }
      if (this.$store.getters.getAppData().context && this.$store.getters.getAppData().context.srfusericonpath) {
        _user.avatar = this.$store.getters.getAppData().context.srfusericonpath;
      }
    }
    if (localStorage.getItem("user")) {
      let user: any = JSON.parse(localStorage.getItem("user") as string);
      if (user && user.personname) {
        _user.name = user.personname;
      }
    }
    Object.assign(this.user, _user, {
      time: +new Date
    });
  }

  /**
   * 退出登录
   *
   * @memberof AppUser
   */
  public logout() {
    const get: Promise<any> = this.$http.get('/runtimeapi/v7/logout');
    get.then((response: any) => {
      if (response && response.status === 200) {
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('menuDataByRole')
        sessionStorage.removeItem('menuDataAll')
        let leftTime = new Date();
        leftTime.setTime(leftTime.getSeconds() - 1);
        document.cookie = "sysuaa-token=;expires=" + leftTime.toUTCString();
        this.$router.push({name: 'login'});
      }
    }).catch((error: any) => {
      console.error(error);
    })
  }

  /**
   * 跳转知识库
   *
   * @memberof AppUser
   */
  public gotoKlg() {
    const get: Promise<any> = this.$http.get('/cssworkorderapi/getKnowledgeBaseUrl?t='+ Date.now());
    get.then((response: any) => {
      if (response && response.status === 200) {
        let url = response.data;
        window.open(url ,"_blank");
      }
    }).catch((error: any) => {
      console.error(error);
    })
  }


  /**
   * 电话条
   *
   * @memberof AppUser
   */
  public showPhoneDialog() {
    let information:any=localStorage.getItem('user')
    var userInfo = JSON.parse(information);
    this.hostExtension = JSON.parse(userInfo.hostExtension)||[]
    this.phoneVisible = true
  }
  /**
   * 二维码
   */
  public showQrCode() {
    this.qrCodeVisible = true
  }

  public hostExtension:any = []
  /**
   * 电话条
   *
   * @memberof AppUser
   */
  public initCallHtml() {
    const refs = (this.$refs) as any;
    if(refs.phoneForm){
      refs.phoneForm.validate((valid:any) => {
        if (valid) {
          this.phoneVisible = false
          const tempThis = this as any;
          //  @ts-ignore
          tempThis.$bus.$emit('phoneInfo', this.phoneInfo)
          // 暂存redis
          this.cache2Redis()
        }
      });
    }else{
          const tempThis = this as any;
          //  @ts-ignore
          tempThis.$bus.$emit('phoneInfo', this.phoneInfo)
    }

  }



  public cache2Redis(){
    let param:any = {
      "agent": null,
      "agentCode": this.phoneInfo.agentId,
      "ext": this.phoneInfo.agentExt,
      "userId": this.getUserId()
      }

      //设置坐席名称
      if(!this.hostExtension.length){
        let information:any=localStorage.getItem('user')
        var userInfo = JSON.parse(information);
        this.hostExtension = JSON.parse(userInfo.hostExtension)||[]
      }
      let nowAgentId = this.phoneInfo.agentId
      let tempHost = this.hostExtension.find(function(item:any){
        return item['hostCode'] == nowAgentId
      });
      param.agent = tempHost.hostName

    const url = '/runtimeapi/employee/cacheUserAgent';
    const post: Promise<any> = this.$http.post(url, param, true);
    post.then((res: any) => {
        if (res && res.status === 200) {
        }
    }).catch(err => {
      console.log(err)
    })
  }

  public getUserAgentFromRedis(){
      const url = '/runtimeapi/employee/getUserAgent';
          const post: Promise<any> = this.$http.post(url, {}, true);
          post.then((res: any) => {
             if (res && res.status === 200) {
              // return res.data
              // 未使用过电话条则需要录入坐席, 否则登录过则不需要弹出框录入
              if(this.isHotLineSpec()&& !res.data?.agent){
                this.showPhoneDialog()
              }else{
                this.phoneInfo = { 'agent':res.data?.agent,  'agentId':res.data?.agentCode,'agentExt':res.data?.ext}
                this.initCallHtml()
              }

              }
          }).catch(err => {
            console.log(err)
          })
  }

  /**
   * 是否是热线客户专员
   */
  public isHotLineSpec() {
    const usr: any = localStorage.getItem('user')
    const extrole: any = usr
                        ? JSON.parse(usr).sessionParams.extrole || []
                        : []
    return extrole.includes('HOTLINE_CUSTOMER_SERVICE_SPECIALIST')
  }

  public getUserId() {
    const usr: any = localStorage.getItem('user')
    return JSON.parse(usr).userId
  }

}
